import { gql } from '@apollo/client';

export const GET_AGENT_TOOLS_LIST = gql`
  query GetAgentToolsList($params: FindAgentToolListInput!) {
    agentTools(params: $params) {
      success
      message
      errors
      data {
        tools {
          id
          agentConfigId
          toolKey
          description
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_AGENT_TOOL = gql`
  query GetAgentTool($params: FindAgentToolInput!) {
    agentTool(params: $params) {
      success
      message
      errors
      data {
        id
        agentConfigId
        toolKey
        description
        createdAt
        createdBy
      }
    }
  }
`;
